/**
 * Available antenna write operations
 *
 * @namespace tmrAntennaWriteOperations
 * @type {ngConstant}
 * @see Antenna
 */
export const constant = [
  'tmrAntennaWriteOperations',
  {
    epc: {
      memoryBank: 'EPC',
      address: 2,
      numBlocks: 6,
      beepOnSuccess: true,
    },
    tid: {
      memoryBank: 'TID',
      address: null,
      numBlocks: null,
    },
    user: {
      memoryBank: 'USER',
      address: null,
      numBlocks: null,
    },
    reserved: {
      memoryBank: 'RESERVED',
      address: null,
      numBlocks: null,
    },
  },
]
